import * as THREE from "three";
import Building from "./Building.js";
import { DragControls } from "./DragControls.js";
import { setIntersectsObjects } from "./raycaster.js";
import { throttle } from "../helpers/throttle.js";
import { setVisibleSpriteTextInObj } from "../helpers/setVisibleSpriteTextInObj.js";
class BuildingWithDragControls extends Building {
    constructor(gltfModel, scene) {
        super(gltfModel, scene);
        this._camera = null;
        this._dragControls = null;
        this._afterDragMove = () => {};
        this._missClick = () => {};
        this._dragStart = () => {};
        this._dragEnd = () => {};
        this._onClick3DHandler = null;
        this.fixedXZ = null;
        this.dragStartScreenY = null;
        this.dragStartObjectY = null;
        this.throttledCheckCollision = throttle(this.checkCollision.bind(this), 200);
        this._collisionCheckScheduled = false;

        this.throttledAfterDragMove = null;
        this.defaultMin = 10.94;
        this.defaultMax = 12.05;

        this.MAX_Y_VALUES = {
            perfopanel__left: {
                min: 11.0349,
                max: 11.5,
            },
            half: {
                min: 10.893833281889103,
                max: 11.531166718110896,
            },
            half_polka_naklonnaya: {
                min: 10.95,
                max: 11.445,
            },
            default: {
                min: this.defaultMin,
                max: this.defaultMax,
            },
            polka_pribornaya__metall: {
                min: 10.975,
                max: 12.025,
            },
            polka_pribornaya__dsp__osveshenie: {
                min: 11.03,
                max: this.defaultMax,
            },
            osveshchenie_verkhnee: {
                min: 11.118,
                max: 12.132,
            },
            osveshchenie_bokovoe: {
                min: 10.97,
                max: 12.011,
            },
            ksm__polka: {
                min: 9.55,
                max: 10,
            },
            ksm__perfopanel: {
                min: 9.98,
                max: 10.265,
            },
            ksm__planka_dlya_lotkov: {
                min: 11.003,
                max: 11.49,
            },
            derzhatelRulonaVerkhnii: {
                min: 11,
                max: this.defaultMax,
            },
            smk__derzhatel_monitora: {
                min: 9.905,
                max: 10.205,
            },
            smk__polka: {
                min: 9.695,
                max: 10.01,
            },
        };
    }
    initBuildingDragControls(camera, renderer) {
        this.camera = servObj.scene.activeCamera;
        const dragControls = new DragControls(
            [
                ...this._all,
                ...this._vertical_only,
                ...this._horizontal_only,
                // ...servObj.activePolkaPribornaya
            ],
            this.camera,
            renderer.domElement,
        );
        this._dragControls = dragControls;
        dragControls.transformGroup = true;
        setIntersectsObjects([
            ...this._all,
            ...this.walls,
            this.floor,
            ...this._vertical_only,
            ...this._horizontal_only,
            // ...servObj.activePolkaPribornaya
        ]);
        let prevActivePosition = new THREE.Vector3();
        if (this._onClick3DHandler) {
            const idx = servObj.onClick3D.indexOf(this._onClick3DHandler);
            if (idx !== -1) servObj.onClick3D.splice(idx, 1);
        }
        this._onClick3DHandler = (intersects) => {
            const notEmptyIntersects = intersects.filter((_) => _.distance > 0);
            const nearestObject = notEmptyIntersects.length ? notEmptyIntersects[0].object : {};
            const isEditMode = servObj.isEditMode || servObj.isRedactorMode;

            const targets = [
                "column",
                "osnovanie",
                "verstak__stoleshnitsa",
                "stoyka",
                "stol",
                "telezhka",
                "tumba__",
                "stellazh",
                "stul",
                "shkaf",
            ];
            const isMatch = targets.some((t) => this.findParentName(nearestObject, t));

            if (isMatch && !isEditMode) {
                let column = nearestObject;
                if (column.parent.name == "column") column = column.parent;
                if (column.name === "column" && !this.isParamsMenuOpen()) return;
                if (column.name == "column") {
                    document.querySelector(".barrier_sizes .length_box input").value = this.getColumnSize(column).x;
                    document.querySelector(".barrier_sizes .width_box input").value = this.getColumnSize(column).z;
                    servObj.active = column;
                    document.querySelector(".assist_btns").classList.toggle("hide", !this.isParamsMenuOpen());
                    document.getElementById("edit").classList.add("hide");
                } else {
                    document.querySelector(".barrier_sizes .length_box input") &&
                        (document.querySelector(".barrier_sizes .length_box input").value = 500); // TODO
                    document.querySelector(".barrier_sizes .width_box input") &&
                        (document.querySelector(".barrier_sizes .width_box input").value = 500);
                    document.getElementById("edit").classList.remove("hide");
                    document.querySelector(".assist_btns").classList.remove("hide");
                }
            } else {
                this.restoreColumnColor();
                this.restoreObjectColor();
                servObj.active = null;
                updateSpriteVisibility();
                document.querySelector(".assist_btns").classList.add("hide");
                document.getElementById("edit").classList.remove("hide");
                this._missClick();
            }
            if (
                isEditMode &&
                nearestObject.userData &&
                (nearestObject.userData?.verticalOnly === true || nearestObject.parent.userData?.verticalOnly === true)
            ) {
                const target = "verticalOnly" in nearestObject.userData ? nearestObject : nearestObject.parent;
                this.coloringObject(target, this.blueColor);
            }
            if (
                isEditMode &&
                nearestObject.userData &&
                (nearestObject.userData?.horizontalOnly === true ||
                    nearestObject.parent.userData?.horizontalOnly === true)
            ) {
                const target = "horizontalOnly" in nearestObject.userData ? nearestObject : nearestObject.parent;
                this.coloringObject(target, this.blueColor);
            }
        };
        servObj.onClick3D.push(this._onClick3DHandler);
        dragControls.addEventListener("hoveron", (event) => {
            // i love three.js!
            let object = event.object;
            if (object.parent?.name === "column") object = object.parent;
            if (this.isColumnObj(object) && !this.isParamsMenuOpen()) return;
            renderer.domElement.style.cursor = "pointer";
            if (servObj.active && servObj.active == object) renderer.domElement.style.cursor = "grab";
            if (servObj.isEditMode || servObj.isRedactorMode) renderer.domElement.style.cursor = "grab";
        });
        dragControls.addEventListener("hoveroff", (event) => {
            renderer.domElement.style.cursor = "auto";
        });
        dragControls.addEventListener("dragstart", (event) => {
            let object = event.object;
            if (!object.parent) return;
            if (this.isColumnObj(object) && !this.isParamsMenuOpen()) return;
            servObj.scene.activeCamera.controls.enabled = false;
            if (object.userData.verticalOnly) {
                this.fixedXZ = {
                    x: object.position.x,
                    z: object.position.z,
                };
                this.dragStartScreenY = event.origEvent ? event.origEvent.clientY : null;
                this.dragStartObjectY = object.position.y;
            }
            if (object.userData.horizontalOnly) {
                this.fixedXZ = {
                    x: object.position.x,
                    y: object.position.y,
                    z: object.position.z,
                };
                this.dragStartScreenX = event.origEvent ? event.origEvent.clientX : null;
                this.dragStartObjectX = object.position.x;
            }
            servObj.scene.activeCamera.controls.enabled = false;
            prevActivePosition = {
                ...object.position,
            };
            renderer.domElement.style.cursor = "grab";
            if (servObj.active && servObj.active == object) renderer.domElement.style.cursor = "grabbing";
            this._dragStart();
        });
        dragControls.addEventListener("dragend", (event) => {
            let object = event.object;
            if (!object.parent) return;
            if (this.isColumnObj(object) && !this.isParamsMenuOpen()) return;
            servObj.scene.activeCamera.controls.enabled = true;
            servObj.active = event.object;
            updateSpriteVisibility(event.object);

            // this.coloringObject(event.object);

            renderer.domElement.style.cursor = "grab";
            this._afterDragMove();
            this._dragEnd();
            this.checkCollision();
        });
        dragControls.addEventListener("drag", (event) => {
            let object = event.object;
            if (!object.parent) return;
            if (this.isColumnObj(object) && !this.isParamsMenuOpen()) return;
            servObj.active = object;
            updateSpriteVisibility(object);
            renderer.domElement.style.cursor = "grabing";
            if (object.userData.verticalOnly && (servObj.isEditMode || servObj.isRedactorMode)) {
                if (this.fixedXZ) {
                    object.position.x = this.fixedXZ.x;
                    object.position.z = this.fixedXZ.z;
                }

                // вычисляем Y по разнице мыши (или по другой логике)
                if (event.origEvent && this.dragStartScreenY !== null && this.dragStartObjectY !== null) {
                    const deltaY = event.origEvent.clientY - this.dragStartScreenY;
                    object.position.y = this.dragStartObjectY - deltaY * 0.005;
                }

                const yLimits = this.getYLimitsByName(object);
                const minY = yLimits.min;
                const maxY = yLimits.max;

                // привязка по шагу, если задан dragStep
                const rawStep = object.userData.dragStep;
                const step = Number.parseFloat(rawStep);
                if (Number.isFinite(step) && step > 0) {
                    // небольшая коррекция на числовую погрешность
                    const eps = 1e-9;
                    object.position.y = minY + Math.round((object.position.y - minY + eps) / step) * step;
                }

                // ограничиваем границами (clamp)
                if (object.position.y < minY) object.position.y = minY;
                if (object.position.y > maxY) object.position.y = maxY;

                this.scheduleCollisionCheck();
                this._afterDragMove();
                return;
            } else if (object.userData.horizontalOnly && (servObj.isEditMode || servObj.isRedactorMode)) {
                if (this.fixedXZ) {
                    object.position.y = this.fixedXZ.y;
                    object.position.z = this.fixedXZ.z;
                }
                if (event.origEvent && this.dragStartScreenX !== null && this.dragStartObjectX !== null) {
                    object.position.y = this.fixedXZ.y;
                    object.position.z = this.fixedXZ.z;

                    const minX = object.userData.max_x_value.min;
                    const maxX = object.userData.max_x_value.max;

                    if (object.position.x < minX) object.position.x = minX;
                    if (object.position.x > maxX) object.position.x = maxX;

                    return;
                }
                return;
            } else {
                if (servObj.isEditMode || servObj.isRedactorMode) return;
                const columnSize = event.object.userData.bSize;
                if (event.object.position.x + columnSize.x / 2 > this.maxX)
                    event.object.position.x = this.maxX - columnSize.x / 2;
                if (event.object.position.x - columnSize.x / 2 < this.minX)
                    event.object.position.x = this.minX + columnSize.x / 2;
                if (event.object.position.z + columnSize.z / 2 > this.maxZ) {
                    event.object.position.z = this.maxZ - columnSize.z / 2;
                    if (event.object.name !== "column") event.object.position.z += 0.0001;
                }
                if (event.object.position.z - columnSize.z / 2 < this.minZ)
                    event.object.position.z = this.minZ + columnSize.z / 2;
                // event.object.position.y = 0;
            }
            this.needsCollisionCheck = true;
            this.scheduleCollisionCheck();
            this.throttledAfterDragMove();
        });
    }
    changeCamera(camera, renderer) {
        this._camera = camera;
        this._dragControls.disconnect();
        this.initBuildingDragControls(camera, renderer);
    }

    getYLimitsByName(object) {
        const { name, userData } = object;
        if (!name) return this.MAX_Y_VALUES.default;
        if (userData.isHalfObj)
            if (name.includes("polka_naklonnaya_")) {
                return {
                    min: this.MAX_Y_VALUES.half_polka_naklonnaya.min,
                    max: this.MAX_Y_VALUES.half_polka_naklonnaya.max,
                };
            } else {
                return {
                    min: this.MAX_Y_VALUES.half.min + userData.bsize.y / 2,
                    max: this.MAX_Y_VALUES.half.max - userData.bsize.y / 2,
                };
            }
        if (
            !userData.isHalfObj &&
            name.includes("perfopanel") &&
            !name.includes("ksm") &&
            !name.includes("smk") &&
            !name.includes("verstak__vs")
        )
            return {
                min: this.MAX_Y_VALUES.default.min + userData.bsize.y / 2,
                max: this.MAX_Y_VALUES.default.max - userData.bsize.y / 2,
            };
        if (!userData.isHalfObj && name.includes("perfopanel") && name.includes("smk"))
            return {
                min: 9.91,
                max: 10.07,
            };
        if (!userData.isHalfObj && name.includes("perfopanel") && name.includes("x700"))
            return {
                min: 9.82,
                max: 10.235,
            };
        if (!userData.isHalfObj && name.includes("perfopanel") && name.includes("x430"))
            return {
                min: 9.825,
                max: 10.495,
            };
        for (const key of Object.keys(this.MAX_Y_VALUES)) {
            if (key !== "default" && name.includes(key)) {
                return this.MAX_Y_VALUES[key];
            }
        }
        if (
            object.name.includes("polka_pribornaya__dsp") &&
            object.children.some((ch) => ch.name.includes("osveshchenie_pod_pribornuyu_polku") && ch.visible === true)
        ) {
            return this.MAX_Y_VALUES.polka_pribornaya__dsp__osveshenie;
        }
        if (name.includes("derzhatel_rulona__verkhnii")) {
            return {
                min: this.MAX_Y_VALUES.derzhatelRulonaVerkhnii.min,
                max: this.MAX_Y_VALUES.derzhatelRulonaVerkhnii.max,
            };
        }
        return this.MAX_Y_VALUES.default;
    }
    isParamsMenuOpen() {
        return document.querySelector(".room_params_menu");
    }
    isColumnObj(obj) {
        return obj.name === "column" || obj.parent.name === "column";
    }
    findParentName(obj, substring) {
        return (
            obj.name &&
            (obj.name.includes(substring) ||
                (obj.parent && obj.parent.name.includes(substring)) ||
                (obj.parent.parent && obj.parent.parent.name.includes(substring)))
        );
    }
    scheduleCollisionCheck() {
        if (this._collisionCheckScheduled) return;
        this._collisionCheckScheduled = true;

        requestAnimationFrame(() => {
            this.checkCollision();
            this._collisionCheckScheduled = false;
        });
    }
    // if has linesGuide
    set afterDragMove(func) {
        this._afterDragMove = func;
        this.throttledAfterDragMove = throttle(this._afterDragMove.bind(this), 15);
    }
    set missClick(func) {
        this._missClick = func;
    }
    set dragStart(func) {
        this._dragStart = func;
    }
    set dragEnd(func) {
        this._dragEnd = func;
    }
}
export default BuildingWithDragControls;

function updateSpriteVisibility(newActive = null) {
    const isEditMode = servObj.isEditMode || servObj.isRedactorMode;

    // 1. скрываем у всех объектов сначала
    servObj.building._all.forEach((obj) => {
        obj.traverse((obj) => {
            if (obj.isSprite) {
                obj.visible = false;
            }
        });
    });

    // 2. если есть активный и мы НЕ в edit mode — показываем
    if (newActive && !isEditMode) {
        setVisibleSpriteTextInObj({
            targetObject: newActive,
            visible: true,
        });
    }
}
